export default [
  {
    path: '',
    name: 'voucher list',
    component: () => import('@/views/app/voucher/list/page-list.vue'),
    meta: { title: 'Daftar Voucher' },
  },
  {
    path: 'baru',
    name: 'voucher create',
    component: () => import('@/views/app/voucher/create/page-create.vue'),
    meta: { title: 'Tambah Voucher' },
  },
  {
    path: 'edit/:id',
    name: 'voucher edit',
    component: () => import('@/views/app/voucher/edit/page-edit.vue'),
    meta: { title: 'Ubah Informasi Voucher' },
  },
  {
    path: ':id',
    name: 'voucher detail',
    component: () => import('@/views/app/voucher/detail/page-detail.vue'),
    meta: { title: 'Detail Informasi Voucher' },
  },
]
